import React from 'react';
import { connect } from 'react-redux';


import { BaseComponent } from "my-utils/core"
import { AppConfig } from "my-constants"
import { MainLayout, AuthenticationLayout } from 'my-pages/layouts'
import { Loading } from 'my-pages/layouts/partials';
import { FlashMessagesContainer } from 'my-containers/systems';
import { CookieService } from 'my-utils/core';
import { changeLanguage } from 'my-actions/systems/LanguageAction';
import { RoutesService } from 'my-routes'

const RenderComponent = () => {
	let component = ( <MainLayout /> );

	// Check user is login? change template
	const byPassDashboard = CookieService.get('byPassDashboard');

	if (!Number(byPassDashboard)) component = <AuthenticationLayout/>;

	return component;
};

class AppPage extends BaseComponent {
	constructor(props) {
		super(props);

		this.props.changeLanguage(AppConfig.DEFAULT_LANG);

		CookieService.addChangeListener(obj => {
			if (obj.name === "byPassDashboard") {
				if(typeof obj.value === 'undefined' || !Number(obj.value)) {
					this.forceUpdate()
				} else {
					
				}
				
			}
		});

		const isLogin = CookieService.get("isLogin");
		const pathname = window.location.pathname;
		const query = window.location.search;

		const params = new URLSearchParams(query);
		const newUser = params.get('user');
		const currentUser = CookieService.get('username');

		if (newUser && currentUser && newUser.toLowerCase() !== currentUser.toLowerCase()) {
			CookieService.removeAll();
			window.location.href = RoutesService.getPath('ADMIN', 'AUTH_LOGIN', { type: 'login' }, query);
			return;
		}

		if(!isLogin && !pathname.match(/\/auth\/login/i)) window.location.href = RoutesService.getPath('ADMIN', 'AUTH_LOGIN', { type: 'login' }, query);
	}

	render() {
		const isLogin = CookieService.get("isLogin");
		const pathname = window.location.pathname;

		if(!isLogin && !pathname.match(/\/auth\/login/i)) return null;

		return (
			<>
				<RenderComponent />
				<Loading />
				<FlashMessagesContainer />
			</>
		);
	}
}


const mapDispatchToProps = dispatch => {
	return {
		changeLanguage: lang_code => dispatch(changeLanguage(lang_code)),
	};
};

export default connect(null, mapDispatchToProps)(AppPage);